// Quoting chargeable actions in the customer portal.
//
// Every action that costs money must be quotable BEFORE the customer triggers
// it. The arithmetic mirrors the server's writeCostEUR exactly — including the
// minimum-billable-size floor — so the quote and the later invoice agree.

import type { TenantPricing } from '../api/types';

/** Decimal GB, matching how the price list quotes "EUR / GB". */
const BILLING_GB = 1_000_000_000;

/** What writing `bytes` costs, or null when the tenant has no priced plan. */
export function writeCost(pricing: TenantPricing | null, bytes: number): number | null {
  if (!pricing?.hasPlan) return null;
  const billable = Math.max(bytes, pricing.minBillableObjectBytes);
  return (billable / BILLING_GB) * pricing.writeEurPerGb;
}

/** Cost of a set of files: the floor applies PER FILE, not to the total. */
export function writeCostForFiles(pricing: TenantPricing | null, sizes: number[]): number | null {
  if (!pricing?.hasPlan) return null;
  return sizes.reduce((sum, s) => sum + (writeCost(pricing, s) ?? 0), 0);
}
